import React from 'react';
import { SxProps, Theme, Typography } from '@mui/material';
import { parseText } from './utils';

const Body = ({
  children,
  handleOnSampleClick,
  sx,
}: {
  children: React.ReactNode;
  handleOnSampleClick: (plan: string) => void;
  sx?: SxProps<Theme>;
}) => {
  const parsedText = parseText(children as string, handleOnSampleClick, 'html');
  return <Typography variant="body1" sx={{ ...sx }}>{parsedText}</Typography>;
};

export default Body;
